export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-no-smoking-a2028c23108aa640cec813153e1b3496.svg";